import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import Seo from '../../components/common/Seo';

export default function NotFound() {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  return (
    <div className="min-h-screen bg-[#021206] text-white flex flex-col">
      <Seo
        title="Page Not Found"
        description="The page you requested could not be found."
        noIndex
      />
      <Navbar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

      <main className="flex-grow flex items-center justify-center px-6 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl"
        >
          <h1 className="text-8xl font-bold text-[#A1FF4F] mb-4">404</h1>
          <h2 className="text-4xl font-bold mb-6">Page Not Found</h2>
          <p className="text-white/70 text-lg mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-3 bg-[#A1FF4F] text-black font-bold rounded-full hover:shadow-[0_0_20px_rgba(161,255,79,0.5)] transition-all duration-300"
          >
            Go Back Home
          </Link>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
